<div class="hr-layout" [class.hkdb-tv-mode]="tvView">
  <app-hygine-sidebar *ngIf="!tvView" [hkdbTheme]="theme"></app-hygine-sidebar>
  <div class="hr-main-content">
    <div class="viewport">
  <div class="hkdb-stage" [attr.data-theme]="theme" [class.hkdb-tv-stage]="tvView">

    <div class="aurora"></div>

    <div class="top">
      <div class="brand">
        <div class="logo">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V8l7-5 7 5v13"/><path d="M9 21v-6h6v6"/><path d="M9 11h.01M15 11h.01"/></svg>
        </div>
        <div>
          <div class="tt">Housekeeping Operations</div>
          <div class="st">Daily Sanitation · India</div>
        </div>
      </div>
      <div class="top-r">
        <div class="when">
          <div class="d" id="date">{{ dateLabel }}</div>
          <div class="t num" id="clock">{{ clockLabel }}<span>IST</span></div>
        </div>
        <button type="button" class="iconbtn" id="soundBtn" [class.muted]="!soundOn" (click)="toggleSound()" aria-label="Toggle sound">
          <svg class="son" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a9 9 0 0 1 0 14"/></svg>
          <svg class="soff" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M22 9l-6 6M16 9l6 6"/></svg>
        </button>
        <button type="button" class="iconbtn" [class.on]="tvView" (click)="toggleTvView()" aria-label="Toggle TV view">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M8 21h8M12 19v2"/></svg>
        </button>
        <button type="button" class="iconbtn" id="themeBtn" (click)="toggleTheme()" aria-label="Toggle theme">
          <svg class="sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>
          <svg class="moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>
        </button>
        <div class="live"><i></i>Live</div>
      </div>
    </div>

    <div class="hkdb-main">
      <div class="panel maphero">
        <div class="ph">
          <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 20l-6-2V6l6 2m0 12l6-2m-6 2V8m6 10l6 2V8l-6-2m0 12V6m0 0L9 8"/></svg>
          <h2>Live Coverage</h2>
          <div class="seg" id="mapSeg" style="margin-left:auto">
            <button type="button" [class.on]="baseMode === 'map'" (click)="setBaseMode('map')">Map</button>
            <button type="button" [class.on]="baseMode === 'sat'" (click)="setBaseMode('sat')">Satellite</button>
            <button
              type="button"
              [class.on]="mapViewDrone"
              [disabled]="baseMode === 'map'"
              (click)="toggleDroneView()">
              Drone
            </button>
            <button
              type="button"
              [class.on]="mapView3d"
              [disabled]="baseMode === 'map'"
              (click)="toggleMap3d()">
              3D
            </button>
          </div>
        </div>
        <div class="mapcanvas">
          <google-map
            *ngIf="!showMap3dElement"
            class="hkdb-google-map"
            height="100%"
            width="100%"
            [center]="mapCenter"
            [zoom]="mapZoom"
            [options]="mapOptions"
            (mapIdle)="onMapIdle()"
            (mapZoomChanged)="onMapZoomChanged()"
            (mapTilesloaded)="onMapTilesLoaded()">
            <map-marker
              *ngFor="let m of mapMarkers; trackBy: trackMapMarker"
              [position]="m.position"
              [title]="m.title"
              [options]="m.options"
              (mapClick)="onMapMarkerClick(m)">
            </map-marker>
          </google-map>
          <div
            #map3dHost
            *ngIf="showMap3dElement"
            class="hkdb-google-map hkdb-map-3d"
            aria-label="3D map view">
          </div>
          <div class="map-blink-layer" aria-hidden="true">
            <ng-container *ngIf="!showMap3dElement">
              <div
                *ngFor="let rip of mapDomRipples; trackBy: trackMapRipple"
                class="hkdb-map-ripple"
                [style.left.px]="rip.x"
                [style.top.px]="rip.y"
                [style.width.px]="rip.size"
                [style.height.px]="rip.size"
                [style.opacity]="rip.opacity">
              </div>
            </ng-container>
            <div
              *ngIf="showMap3dElement && map3dRippleActive"
              class="hkdb-map-ripple hkdb-map-ripple--3d">
            </div>
            <div
              *ngIf="mapFocusLabel as label"
              class="hkdb-map-focus-label"
              [class.hkdb-map-focus-label--3d]="showMap3dElement"
              [style.left.px]="showMap3dElement ? null : label.x"
              [style.top.px]="showMap3dElement ? null : label.y">
              {{ label.name }}
            </div>
          </div>
          <div class="scrim"></div>
          <div class="mtag"><i></i>Real-time site status</div>
          <div class="mapfilter" id="mapFilter" [style.display]="selectedIncharge !== null ? 'flex' : 'none'">
            <span>Showing</span> <b id="mapFilterName">{{ filterInchargeName }}</b>
            <button type="button" id="mapFilterX" (click)="clearIncFilter()" aria-label="Clear filter">✕</button>
          </div>
        </div>
      </div>

      <div class="side">
        <div class="panel spot">
          <div class="ph">
            <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>
            <h2>Live Upload</h2>
            <div class="meta">Latest site photo</div>
          </div>
          <div class="spotbody" (mouseenter)="pauseLiveSlider()" (mouseleave)="resumeLiveSlider()">
            <div class="idle scard" *ngIf="!liveUpload || !liveUploadImages.length">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M7 10l5 5 5-5"/><path d="M12 15V3"/></svg>
              <span>WAITING FOR NEXT UPLOAD…</span>
            </div>

            <div class="scard in" *ngIf="liveUpload && liveUploadImages.length">
              <div class="pic">
                <img
                  class="img"
                  [src]="liveUploadImages[liveImageIndex]"
                  [alt]="liveUpload.buildingName"
                  (error)="onLiveImageError(liveUploadImages[liveImageIndex])" />
                <div class="geo">
                  <i></i>
                  <div class="geo-text">
                    <div class="geo-top">
                      <span class="geo-loc">{{ liveUploadLocationLabel }}</span>
                      <span
                        class="geo-time"
                        *ngIf="liveUploadTimeLabel && liveUploadTimeLabel !== '--:--'"
                      >{{ liveUploadTimeLabel }}</span>
                    </div>
                    <span class="geo-who" *ngIf="liveUpload.uploadedBy">{{ liveUpload.uploadedBy }}</span>
                  </div>
                </div>

                <ng-container *ngIf="liveUploadImages.length > 1">
                  <button type="button" class="hkdb-slider-btn left" (click)="prevLiveImage()" aria-label="Previous image">‹</button>
                  <button type="button" class="hkdb-slider-btn right" (click)="nextLiveImage()" aria-label="Next image">›</button>
                  <div class="hkdb-slider-counter">{{ liveImageIndex + 1 }} / {{ liveUploadImages.length }}</div>
                  <div class="hkdb-slider-dots">
                    <button
                      type="button"
                      *ngFor="let img of liveUploadImages; let i = index"
                      [class.on]="i === liveImageIndex"
                      (click)="goLiveImage(i)"
                      [attr.aria-label]="'Image ' + (i + 1)">
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <div class="panel incharge">
          <div class="ph">
            <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13A4 4 0 0 1 16 11"/></svg>
            <select
              class="follow-select"
              [(ngModel)]="followUpView"
              (ngModelChange)="onFollowUpViewChange($event)"
              aria-label="Follow-up grouping">
              <option value="city">City</option>
              <option value="state">State</option>
              <option value="incharge">Incharge</option>
            </select>
          </div>
          <div
            #inchargeGrid
            class="icgrid"
            id="inchargeWrap"
            (mouseenter)="pauseInchargeAutoScroll()"
            (mouseleave)="resumeInchargeAutoScroll()">
            <div
              class="icc"
              *ngFor="let card of inchargeCards; let idx = index"
              [class.worst]="idx === inchargeCards.length - 1"
              [class.sel]="selectedIncharge === card.i"
              (click)="onInchargeClick(card.i)">
              <div class="n">{{ card.n }}</div>
              <div class="r">
                <span class="c">{{ card.done }}/{{ card.total }}</span>
                <span class="p">{{ card.pct }}%</span>
              </div>
              <div class="l">
                <i [style.width.%]="card.pct" [style.background]="card.low ? 'linear-gradient(90deg,var(--alert),var(--warn))' : 'linear-gradient(90deg,var(--ok),var(--info))'"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="band" id="band">
      <div class="stat"><span class="accent" style="--c:var(--brand)"></span><div class="l">Total Campuses</div><div class="vrow"><div class="v num" id="sTotal">0</div></div><div class="sub">across <b style="--c:var(--brand)">35</b> states & UTs</div></div>
      <div class="stat"><span class="accent" style="--c:var(--ok)"></span><div class="l">Campus Photo Taken Count</div><div class="vrow"><div class="v num" id="sClean">0</div><svg class="spark" id="sparkClean" viewBox="0 0 62 24" preserveAspectRatio="none"></svg><div class="delta" id="dClean" style="color:var(--ok)">+1</div></div><div class="sub"><b style="--c:var(--ok)" id="sCleanPct">0%</b> of target</div></div>
      <div class="stat"><span class="accent" style="--c:var(--alert)"></span><div class="l">Campuses Pending</div><div class="vrow"><div class="v num" id="sPend">0</div><svg class="spark" id="sparkPend" viewBox="0 0 62 24" preserveAspectRatio="none"></svg></div><div class="sub"><b style="--c:var(--alert)" id="sPendPct">0%</b> need follow-up</div></div>
      <div class="stat"><span class="accent" style="--c:var(--violet,#9485f2)"></span><div class="l">Total Employees</div><div class="vrow"><div class="v num" id="sEmp">0</div></div><div class="sub">deployed on shift</div></div>
      <div class="stat"><span class="accent" style="--c:var(--info)"></span><div class="l">Staff Checked In</div><div class="vrow"><div class="v num" id="sIn">0</div><svg class="spark" id="sparkIn" viewBox="0 0 62 24" preserveAspectRatio="none"></svg><div class="delta" id="dIn" style="color:var(--info)">+</div></div><div class="sub"><b style="--c:var(--info)" id="sInPct">0%</b> attendance</div></div>
      <div class="stat"><span class="accent" style="--c:var(--warn)"></span><div class="l">{{ staffPendingLabel }}</div><div class="vrow"><div class="v num">{{ staffPendingDisplay }}</div></div><div class="sub">{{ staffPendingSub }}</div></div>
    </div>

    <!-- <div class="ticker">
      <div class="tg">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11l18-5v12L3 14v-3zM11.6 16.8a3 3 0 1 1-5.8-1.6"/></svg>
        Ops Feed
      </div>
      <div class="run"><div class="mv" id="tickMove"></div></div>
    </div> -->

  </div>
    </div>
  </div>
</div>
